import { PayloadAction } from '@reduxjs/toolkit';
import { BottomSheetContext, BottomSheetState } from '@reducers/v2/bottomSheet/bottomSheet.slice';

export const pushBottomSheetAction = (state: BottomSheetState, action: PayloadAction<BottomSheetContext>) => {
	state.stack.push(action.payload);
};
